import blastocyst from "./images/blastocyst.png";

/**
 * Approved, reusable subject illustrations. Use these semantic names rather
 * than importing a feature-specific copy. See docs/development/IMAGE_ASSETS.md.
 */
export const illustrations = {
  /** Cell-stage blastocyst: outer cell ring, cavity and inner cell mass. */
  blastocyst,
} as const;
